module.exports = __webpack_public_path__ + "media/img/pages/companies/bundesverwaltung-5c6bb3de24debdc1b29752d9cc8bffe9.png";